import React from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

// Aceternity Lamp — light variant. White canvas, BookingFlows-blue beam.
export const LampLight = ({ className, children, ...props }) => (
  <div className={cn("relative overflow-hidden bg-white", className)} {...props}>
    <div className="relative h-[300px] w-full flex items-center justify-center isolate z-0 pointer-events-none" aria-hidden="true">
      <motion.div
        initial={{ opacity: 0.4, width: "16rem" }}
        whileInView={{ opacity: 1, width: "30rem" }}
        viewport={{ once: true }}
        transition={{ delay: 0.25, duration: 0.9, ease: "easeInOut" }}
        style={{ backgroundImage: "conic-gradient(from 70deg at center top, rgba(37,99,235,0.42), transparent 30%)" }}
        className="absolute inset-auto right-1/2 h-56 w-[30rem]"
      >
        <div className="absolute w-full left-0 bg-white h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" />
        <div className="absolute w-40 h-full left-0 bg-white bottom-0 z-20 [mask-image:linear-gradient(to_right,white,transparent)]" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0.4, width: "16rem" }}
        whileInView={{ opacity: 1, width: "30rem" }}
        viewport={{ once: true }}
        transition={{ delay: 0.25, duration: 0.9, ease: "easeInOut" }}
        style={{ backgroundImage: "conic-gradient(from 290deg at center top, transparent 70%, rgba(37,99,235,0.42))" }}
        className="absolute inset-auto left-1/2 h-56 w-[30rem]"
      >
        <div className="absolute w-40 h-full right-0 bg-white bottom-0 z-20 [mask-image:linear-gradient(to_left,white,transparent)]" />
        <div className="absolute w-full right-0 bg-white h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" />
      </motion.div>
      <div className="absolute top-1/2 h-48 w-full translate-y-12 scale-x-150 bg-white blur-2xl" />
      <div className="absolute inset-auto z-50 h-36 w-[28rem] -translate-y-1/2 rounded-full bg-blue-500 opacity-20 blur-3xl" />
      <motion.div
        initial={{ width: "8rem" }}
        whileInView={{ width: "16rem" }}
        viewport={{ once: true }}
        transition={{ delay: 0.25, duration: 0.9, ease: "easeInOut" }}
        className="absolute inset-auto z-30 h-36 w-64 -translate-y-[6rem] rounded-full bg-blue-400/30 blur-2xl"
      />
      <motion.div
        initial={{ width: "15rem" }}
        whileInView={{ width: "30rem" }}
        viewport={{ once: true }}
        transition={{ delay: 0.25, duration: 0.9, ease: "easeInOut" }}
        className="absolute inset-auto z-50 h-0.5 w-[30rem] -translate-y-[7rem] bg-blue-500"
      />
      <div className="absolute inset-auto z-40 h-40 w-full -translate-y-[12.7rem] bg-white" />
    </div>
    <div className="relative z-50 -mt-44 pb-16 sm:pb-20">{children}</div>
  </div>
);
